<template>
  <div class="dialog company-fadeIn" v-if="visible">
    <div class="logo">
      <img src="@/assets/img/logo.png" alt=""/>
      <div>
        <h2>
          四川省久辉电力设备有限公司
        </h2>
        <span>
          Sichuan Jiuhui Power Equipment Co., Ltd
        </span>
      </div>
    </div>
    <div class="content">
      <span>电话：13699414765</span>
      <span>固话：028-64627660</span>
      <span>邮箱：576546387@qq.com</span>
      <span>地址：成都市高新区天府四街号2栋7层2号</span>
    </div>
    <i class="iconfont icon-guanbi" @click="close"/>
  </div>
</template>

<script>
export default {
  name: "CompanyInfo",
  props: {
    visible: {
      type: Boolean,
      require: true
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  background-color: #fff;
  position: fixed;
  left: 50%;
  top: 50%;
  //width: 40%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 999;

  padding: 3%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  box-shadow: -1px 2px 5px 3px rgba(0, 0, 0, 0.1);;

  .logo {
    display: flex;
    align-items: center;

    img {
      height: 90px;
    }

    div {
      margin-left: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .content {
    margin-top: 30px;
    display: flex;
    flex-direction: column;

    span {
      line-height: 40px;
    }
  }

  .icon-guanbi {
    position: absolute;
    right: 20px;
    top: 20px;

  }

  .icon-guanbi:hover {
    cursor: pointer;
    color: $basic-color;
  }
}

.company-fadeIn {
  animation: company-fadeIn 1s linear;
}

@keyframes company-fadeIn {
  from {
    opacity: 0.1;
    transform: translate3d(-50%, -50%, 0) scale(0.5);
    -webkit-transform: translate3d(-50%, -50%, 0) scale(0.5);
  }

  to {
    opacity: 1;
    transform: translate3d(-50%, -50%, 0) scale(1);
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1);
  }
}

@-webkit-keyframes company-fadeIn {
  from {
    opacity: 0.1;
    transform: translate3d(-50%, -50%, 0) scale(0.5);
    -webkit-transform: translate3d(-50%, -50%, 0) scale(0.5);
  }

  to {
    opacity: 1;
    transform: translate3d(-50%, -50%, 0) scale(1);
    -webkit-transform: translate3d(-50%, -50%, 0) scale(1);
  }
}
</style>